import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../../../root-saga/root-state';
import { initialState } from '.';

const selectSlice = (state: RootState) => state.projects || initialState;

export const selectProjects = createSelector(
  [selectSlice],
  (state) => state.items,
);

export const selectProjectsLoading = createSelector(
  [selectSlice],
  (state) => state.loading,
);

export const selectProjectCreating = createSelector(
  [selectSlice],
  (state) => state.creating,
);
